namespace GeniuzPOS.Member {
    export interface MbReport01Row {
        Id?: string;
        MbId?: string;
        MbType?: string;
        MemberTypeDesc?: string;
        MbNameT?: string;
        MbNameE?: string;
        MbAddress?: string;
        MbProvince?: string;
        MbAmphur?: string;
        MbTumbol?: string;
        MbZipCode?: string;
        MbGender?: string;
        MbNation?: string;
        MbRace?: string;
        MbOccupation?: string;
        MbBirthDay?: string;
        MbCardStatus?: number;
        MbAccumPoint?: number;
        MbMemo?: string;
        GrossSales?: number;
        AllItemDiscount?: number;
        NetSales?: number;
        NetSalesExVat?: number;
        VatOfNetSales?: number;
        AllItemCharge?: number;
        VatOfCharge?: number;
        DtList?: MbReport01_DtRow[];
        PluDtList?: MbReport_01_Dt_PluRow[];
    }

    export namespace MbReport01Row {
        export const idProperty = 'MbId';
        export const nameProperty = 'MbId';
        export const localTextPrefix = 'Member.MbReport01';
        export const deletePermission = '3Member:สถานะสมาชิก:View';
        export const insertPermission = '3Member:สถานะสมาชิก:View';
        export const readPermission = '3Member:สถานะสมาชิก:View';
        export const updatePermission = '3Member:สถานะสมาชิก:View';

        export declare const enum Fields {
            Id = "Id",
            MbId = "MbId",
            MbType = "MbType",
            MemberTypeDesc = "MemberTypeDesc",
            MbNameT = "MbNameT",
            MbNameE = "MbNameE",
            MbAddress = "MbAddress",
            MbProvince = "MbProvince",
            MbAmphur = "MbAmphur",
            MbTumbol = "MbTumbol",
            MbZipCode = "MbZipCode",
            MbGender = "MbGender",
            MbNation = "MbNation",
            MbRace = "MbRace",
            MbOccupation = "MbOccupation",
            MbBirthDay = "MbBirthDay",
            MbCardStatus = "MbCardStatus",
            MbAccumPoint = "MbAccumPoint",
            MbMemo = "MbMemo",
            GrossSales = "GrossSales",
            AllItemDiscount = "AllItemDiscount",
            NetSales = "NetSales",
            NetSalesExVat = "NetSalesExVat",
            VatOfNetSales = "VatOfNetSales",
            AllItemCharge = "AllItemCharge",
            VatOfCharge = "VatOfCharge",
            DtList = "DtList",
            PluDtList = "PluDtList"
        }
    }
}
